<script lang="ts" setup>
	import useAccountApi from '~/services/apis/account'
	import { useResourcesApi } from '~/services/apis/resources'

	const { validateCustomerCACNumber } = useResourcesApi()
	const { cacModalOpen, User } = reactor(useUser())
	const formModel = reactive({
		business_type: null as string | null,
		cac_number: ''
	})
	const businessInitial = shallowRef('')
	const validating = shallowRef(false)
	const updatingAccount = shallowRef(false)
	const { GetAccountInfo } = useAccountApi()
	const handleCACVerification = async () => {
		const response = await resolve(async () => validateCustomerCACNumber(formModel.cac_number), validating)

		if (response?.data?.customer?.meta?.cac_verified) {
			await resolve(() => GetAccountInfo(), updatingAccount)
			useNotification().alert({
				status: 200,
				message: 'Your business can now enjoy full insurance benefits.'
			})
			cacModalOpen.value = false
		} else if (!response?.data?.customer?.meta?.cac_verified) {
			useNotification().alert({
				status: 500,
				message: 'Your current business name does not match the CAC credentials you provided'
			})
		}
	}
	const checkBusinessType = (value: SelectOptionContext[number]) => {
		if (value?.initial) {
			businessInitial.value = value.initial
		}
	}
</script>

<template>
	<div>
		<dialogs v-model:show="cacModalOpen" btn-position="center" title="">
			<template #title>
				<header>
					<h3 class="w-full border-b py-[15px] text-center">Complete CAC Verification</h3>
					<p
						class="mb-[54px] max-w-[500px] pt-[24px] text-center text-base font-medium leading-snug text-[#475466]"
					>
						Your CAC number is required for your business to be verified. Complete it below.
					</p>
				</header>
			</template>
			<div class="relative">
				<a-form
					:colon="false"
					:model="formModel"
					:validate-messages="antValidateMessages"
					@finish="handleCACVerification"
				>
					<forms-business-type-field v-model="formModel.business_type" @selected="checkBusinessType" />
					<forms-cac-field
						v-model="formModel.cac_number"
						:type="businessInitial"
						:business-name="User?.customer?.name ?? ''"
						:verify="false"
					/>

					<div class="pt-[40px]">
						<ui-button type="submit" variants="one" class="w-full" :loading="validating">
							Submit
						</ui-button>
					</div>
				</a-form>
			</div>
		</dialogs>
		<loader-with-text :active="updatingAccount" text="updating profile" />
	</div>
</template>
